import React from "react";
import { View, Text } from "react-native";
import { AnimatedCircularProgress } from "react-native-circular-progress";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { DEVICE_SIZES } from "rn-responsive-styles";

const CardProgressBar = ({
  showProgressBar = true,
  size,
  width,
  fill,
  tintColor,
  label,
  name,
  fontStyle = AppFontStyle.SEMIBOLD_ANYBODY_6,
  deviceSize
}) => {
  return (
    <View
      style={{
        alignItems: "stretch",
        flexDirection: "row",
        gap: 5,
        // width: deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 122 : 215,
        // height: deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 26 : 45,
        alignContent : "center",
        bottom : deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 5 : null,
      }}
    >
      {showProgressBar && <AnimatedCircularProgress
        rotation={0}
        size={size}
        width={width}
        fill={fill} // Use fill directly
        tintColor={tintColor}
        backgroundColor={`${tintColor}70`}
      >
        {(fillValue) => (
          <Text
            style={[
              AppFontStyle.SEMIBOLD_ANYBODY_10,
              { color: AppColors.white },
            ]}
          >
            {Math.round(fillValue)}
          </Text>
        )}
      </AnimatedCircularProgress>}
      <View style={{
        justifyContent: "center",
        backgroundColor: AppColors.red_AF0707,
        borderRadius: 7,
        width: deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 87 : 155,
        height: deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 12 : 20,
        alignSelf: "center",
      }}>
        <Text
          style={[
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? AppFontStyle.SEMIBOLD_ANYBODY_6 : fontStyle,
            {
              color: AppColors.white,
              textAlign: "center",
              alignSelf: "center",
            },
          ]}
        >
          {label}
        </Text>
      </View>
    </View>
  );
};

export default CardProgressBar;
